import { UserType } from '../types/User';

export const defaultUser: UserType = {
  firebaseUserId: '',
  email: '',
  name: '',
  startDate: '',
  endDateTrial: '',
  paypalSubscriptionInfo: null,
  active: false,
  flagsDelivery: null,
  coupon: '',
  onlyWifiDownload: false,
  onlyWifiStreaming: false,
  alexaToken: null,
  createdDate: '',
  tester: false,
  startDateTime: 0,
  endDateTrialTime: 0,
  uid: null
};
